import { render, staticRenderFns } from "./topUp.vue?vue&type=template&id=1fca468d&scoped=true"
import script from "./topUp.vue?vue&type=script&lang=js"
export * from "./topUp.vue?vue&type=script&lang=js"
import style0 from "./topUp.vue?vue&type=style&index=0&id=1fca468d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fca468d",
  null
  
)

export default component.exports